<template>
  <input
    :class="[...colors, 'shadow-sm border rounded w-full py-1 px-3 text-sm']"
    :id="id"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    @blur="$emit('blur', $event)"
    @keyup="$emit('keyup', $event)"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
  export default {
    name: 'BaseInput',

    props: {
      id: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      value: {
        type: [Number, String, Boolean, Array],
        default: '',
      },
      type: {
        type: String,
        default: 'text',
        validator: (v) => {
          return ['text', 'password'].indexOf(v) !== -1;
        },
      },
      autocomplete: {
        type: String,
        default: 'on',
      },
      hasError: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      colors() {
        if (this.hasError) {
          return ['border-permanentGeraniumLake'];
        }

        return [
          'outline-none',
          'border-metallicSilver',
          'hover:border-darkCharcoal',
          'focus:border-darkCharcoal focus:shadow-outline--maximumBluePurple',
        ];
      },
    },
  };
</script>

<style lang="scss">
  .focus\:shadow-outline--maximumBluePurple:focus {
    box-shadow: 0 0 0 3px rgba(157, 169, 242, 0.5);
  }
  input[disabled] {
    background-color: #D9D9DE;
    cursor: not-allowed;
  }
</style>
